import { CurrentUserConfig } from "@/features/Auth/CurrentUser/Config/CurrentUserConfig";

const SYNC_KEY = CurrentUserConfig.storageTokenKeyName + '_sync';

class AccessTokenStorageService {
    public getTokenFromStorage() {

        try {
            const token = localStorage.getItem(CurrentUserConfig.storageTokenKeyName);
            if (token === null) {
                return "";
            }
            return token;
        } catch(e: unknown) {
            return "";
        }
        
    }

    public setTokenToStorage({ token }: { token: string }) {
        localStorage.setItem(CurrentUserConfig.storageTokenKeyName, token);
        localStorage.setItem(SYNC_KEY, Date.now().toString());
    }

    public removeTokenFromStorage() {
        localStorage.removeItem(CurrentUserConfig.storageTokenKeyName);
        localStorage.setItem(SYNC_KEY, Date.now().toString());
    }

    public static onTokenChanged(callback: () => void): () => void {
        const handler = (e: StorageEvent) => {
            if (e.key === SYNC_KEY) {
                callback();
            }
        };
        window.addEventListener('storage', handler);
        return () => window.removeEventListener('storage', handler);
    }
}

export { AccessTokenStorageService }